// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"3461d9602d1f4c1d9882","339":"933c3b3a07ce9386f065"}[chunkId] + ".js";
};